






























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import HandleWarning from "../../../store/entities/handlewarning";
@Component
export default class EditHandlewarnings extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  handleWarning: HandleWarning = new HandleWarning();
  save() {
    (this.$refs.handlewarningForm as any).validate(async (valid: boolean) => {
      if (valid) {
      this.handleWarning.handlerTwo = this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
      this.handleWarning.hIdTwo = this.$store.state.session.user
      ? this.$store.state.session.user.id
      : 0;
      this.handleWarning.hTime = new Date();
      console.log(this.handleWarning.hTime);
      this.handleWarning.htype = 1;
        await this.$store.dispatch({
          type: "thhandlewarning/update",
          data: this.handleWarning,
        });
        (this.$refs.handlewarningForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.handlewarningForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.handleWarning = Util.extend(true, {}, this.$store.state.thhandlewarning.editHandlewarnings);
    }
  }
   handlewarningRule = {
    hContent: [{ required: true, message: "请输入处理内容", trigger: "blur" }],
  };
}
